import { Logo } from './Logo.js';

const LINKS = [
  { label: 'Product', href: '#product' },
  { label: 'Solutions', href: '#solutions' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Company', href: '#company' },
];

export function Navbar() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-6 sm:px-10 md:px-14 py-4 sm:py-5">
      <nav className="flex items-center justify-between">
        <a href="/" className="flex items-center gap-2.5">
          <Logo className="w-6 h-6" />
          <span className="font-semibold text-base tracking-tight text-ink">Legate</span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-ink/70 hover:text-ink transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Primary CTA. The accent is the blue of the mark, in both themes. */}
        <a
          href="/app"
          className="px-5 py-2.5 bg-accent text-white text-sm font-medium rounded-lg hover:bg-accent-hover transition-colors duration-200"
        >
          Dashboard
        </a>
      </nav>
    </header>
  );
}

export default Navbar;
